import './css/styles.scss';

/**
 * Pausar bakgrundsvideon när besökaren valt reducerad rörelse i sitt operativsystem.
 * Videon är rent dekorativ, så den ska inte spela för någon som bett om ett lugnare
 * gränssnitt. CSS döljer elementet, men videon måste pausas också — annars fortsätter
 * den ladda och spela i bakgrunden.
 */
function videoHeroInit(): void {
	const videos = document.querySelectorAll<HTMLVideoElement>('.video-hero__video');

	if (!videos.length) {
		return;
	}

	const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

	const applyMotionPreference = (): void => {
		videos.forEach((video) => {
			if (reduceMotion.matches) {
				video.pause();
				return;
			}

			// Autoplay kan blockeras av webbläsaren. Då visas posterbilden istället,
			// så felet behöver inte hanteras vidare.
			void video.play().catch(() => undefined);
		});
	};

	applyMotionPreference();
	reduceMotion.addEventListener('change', applyMotionPreference);
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', videoHeroInit);
} else {
	videoHeroInit();
}
